module.exports = __webpack_public_path__ + "97253d40b590438b54cadeaa948fbd79.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/expression-rage-s.png
// module id = 1807
// module chunks = 0